/* src/modules/office/utils/dateHelpers.js */

// Generate date range array
export const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    let curr = new Date(startDate);
    const end = new Date(endDate);
    while (curr <= end) {
        dates.push(new Date(curr));
        curr.setDate(curr.getDate() + 1);
    }
    return dates;
};

// Check if a date falls on a weekend
export const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
};

// Get lowercase day name (monday, tuesday...)
export const getDayName = (date) => 
    date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

// ✅ NEW: Robust Date Formatter (Prevents Timezone Shifts)
// Converts a Date object to "YYYY-MM-DD" using local time, not UTC.
export const formatDateLocal = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};